import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {CreateUpdateEntityView} from '@ozgene/gp5.components.create-update-entity-view';
import ProcessOutcomeEditor from 'ProcessOutcomeUpdateCreate/Views/ProcessOutcomeEditor';
import {
  findSbsOutcomeById,
  saveSbsProcessOutcome,
} from 'ProcessOutcomeLobby/service/ProcessOutcomeService';

function ProcessOutcomeUpdateCreate(props, context) {
  const {
    params: {sbsId: id, processOutcomeId},
  } = props;
  const {router} = context;
  const [entity, setEntity] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const handleSaveProcessOutcome = async (processOutcome) => {
    processOutcome = {...processOutcome, sbs: {id}};
    await saveSbsProcessOutcome(processOutcome);
    router.push(`/Sbss/${id}`);
  };
  const getEntityLabel = ({outcome}) => outcome;

  useEffect(() => {
    const retrieveOutcomeSbs = async () => {
      const procOutcome = await findSbsOutcomeById(processOutcomeId);

      setEntity(procOutcome);
      setIsLoading(false);
    };

    !!processOutcomeId ? retrieveOutcomeSbs() : setIsLoading(false);
  }, [processOutcomeId]);

  return (
    !isLoading && (
      <CreateUpdateEntityView
        entityType="Process Outcome"
        EditorComponent={ProcessOutcomeEditor}
        onSave={handleSaveProcessOutcome}
        entity={entity}
        getEntityLabel={getEntityLabel}
      />
    )
  );
}

ProcessOutcomeUpdateCreate.propTypes = {
  params: PropTypes.shape({
    sbsId: PropTypes.string,
    processOutcomeId: PropTypes.string,
  }),
};

ProcessOutcomeUpdateCreate.defaultProps = {
  errorDialogText: '',
};

ProcessOutcomeUpdateCreate.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default ProcessOutcomeUpdateCreate;
